import { useQuery } from "@tanstack/react-query";
import { get } from "../../api/client";

export const STUDENTS_LIST_KEY = {
  STUDENTS_LIST: "STUDENTS_LIST",
};

export const useStudentsLists = ({
  page,
  filters,
}: {
  page: number;
  filters: {
    studentName?: string;
    classId?: number | null;
    branchId?: number | null;
  };
}) =>
  useQuery([STUDENTS_LIST_KEY.STUDENTS_LIST, page, filters], () =>
    get({ url: "api/v1/students/students-list", params: { page, filters } }),
  );
